import { Outlet } from "react-router-dom";
import HomeNav from "./HomeNav";
import HomeHeader from "./HomeHeader";
import { useState } from "react";

const DashLayout = () => {
  const [open, setOpen] = useState(true);
  // // console.log(open);
  
  return (
    <>
      <main className="flex overflow-hidden w-full h-full">
        <HomeNav open={open} setOpen={setOpen} />
        <section className="overflow-hidden h-screen w-full font-bold">
          <HomeHeader title="Welcome" />
          <Outlet  context={{ open, setOpen }}/>
        </section>
      </main>
    </>
  );
};
export default DashLayout;
